import { lessonnote } from './moduledetails';

export type LessonGameKind = 'match' | 'sequence' | 'flashcard';

export class PlayItem {
  id: number = 0;
  text: string = '';
}

export class FlashcardCard {
  id: number = 0;
  front: string = '';
  back: string = '';
}

// What a student (or admin, previewing) receives to play. Match/Sequence are shuffled
// server-side and carry nothing that reveals the correct pairing or order. Flashcards have
// no answer to hide — front and back both arrive; the flip is purely a client-side reveal.
export class LessonGamePlay {
  id: number = 0;
  page: number = 0;
  gameType: LessonGameKind = 'match';
  title: string = '';
  terms: PlayItem[] = [];
  definitions: PlayItem[] = [];
  steps: PlayItem[] = [];
  cards: FlashcardCard[] = [];
  // Present only on a copy saved for offline (GET lessongamesoffline). When present, an
  // attempt is checked on the device instead of by the server - see check-game-attempt.ts.
  answers?: LessonGameAnswers;
}

export class MatchPairAnswer {
  termId: number = 0;
  defId: number = 0;
  term: string = '';
  definition: string = '';
}

export class LessonGameAnswers {
  pairs?: MatchPairAnswer[];      // Match only
  orderedSteps?: PlayItem[];      // Sequence only, in the correct order
}

export class MatchPairEdit {
  termId: number = 0;
  defId: number = 0;
  term: string = '';
  definition: string = '';
}

export class SequenceStepEdit {
  id: number = 0;
  text: string = '';
  correctPosition: number = 0;
}

// What an admin creates/edits with — carries the answer key, only ever sent to
// addeditlessongame / lessongamesforedit (both admin-gated).
export class LessonGameEdit {
  id: number = 0;
  schoolModuleClassID: number = 0;
  page: number = 0;
  gameType: LessonGameKind = 'match';
  title: string = '';
  pairs: MatchPairEdit[] = [];
  steps: SequenceStepEdit[] = [];
  cards: FlashcardCard[] = [];
}

export class MatchAnswer {
  termId: number;
  defId: number;
  constructor(termId: number, defId: number) {
    this.termId = termId;
    this.defId = defId;
  }
}

export class GameAttemptSubmission {
  gameId: number = 0;
  matches: MatchAnswer[] = [];
  orderedStepIds: number[] = [];
  confirmedCardIds: number[] = [];
}

export class CorrectPair {
  term: string = '';
  definition: string = '';
}

export class GameAttemptResult {
  allCorrect: boolean = false;
  correctTermIds: number[] = [];
  incorrectTermIds: number[] = [];
  correctPairs: CorrectPair[] = [];
  correctOrder: string[] = [];
  pendingCardIds: number[] = [];
}

// One slot in a lesson's content sequence — a Note (existing) or a Game (new) — merged and
// ordered by `page` for the lesson player to walk through.
export class LessonPageBlock {
  page: number = 0;
  kind: 'note' | 'game';
  note?: lessonnote;
  game?: LessonGamePlay;
  attempted: boolean = false;
}
